import React, { Dispatch, ReactElement, SetStateAction, useState } from 'react';
import { createContext, useContextSelector } from 'use-context-selector';
import { BlockState } from 'store/types/block';

const initialState: BlockState = {
  data: [],
  masterData: [],
  isLoading: false,
  isSubmitLoading: false,
  selectedBlockIndex: null,
};

const BlockContext = createContext<{
  state: BlockState;
  setState: Dispatch<SetStateAction<BlockState>>;
}>({
  state: initialState,
  setState: () => null,
});

const useBlockStateSelector = (): BlockState =>
  useContextSelector(BlockContext, context => context.state);

interface Props {
  children: ReactElement;
}

const BlockContextProvider = (props: Props): ReactElement => {
  const [state, setState] = useState(initialState);
  return (
    <BlockContext.Provider value={{ state, setState }}>
      {props.children}
    </BlockContext.Provider>
  );
};

export { BlockContext, useBlockStateSelector, BlockContextProvider };
